import { computed, defineComponent, reactive, watch } from '@vue/composition-api';
import { useUnreadNotificationsQuery } from '@/generated-types/graphql.types';
export default defineComponent({
    setup(_, context) {
        const { emit } = context;
        const user = computed(() => globalThis.$store.getters['$_app/user']);
        const variables = reactive({ accountId: user.value?.account_id });
        watch(() => user.value, () => {
            variables.accountId = user.value?.account_id;
        }, { immediate: true });
        // Ten-second poll, replacing a subscription that was itself a
        // ten-second loop. `no-cache` so each poll reaches the server rather
        // than being answered from the Apollo cache, which is what made the
        // websocket feel live.
        const { result } = useUnreadNotificationsQuery(variables, () => ({
            enabled: !!variables.accountId,
            pollInterval: 10000,
            fetchPolicy: 'no-cache'
        }));
        const notificationsCounter = computed(() => result?.value?.unread_notification_count?.count);
        watch(() => notificationsCounter.value, () => {
            emit('has-new-notifications', notificationsCounter.value);
        }, { immediate: true });
        return {
            notificationsCounter
        };
    }
});
